import { useTranslation } from 'react-i18next';
import useGuidebookRedirect from 'hooks/guidebook/useGuidebookRedirect';
import useGetHostfullyDevicesUrl from 'hooks/hostfullyDevices/useGetHostfullyDevicesUrl';
import useHostfullyAccountingRedirect from 'hooks/hostfullyAccounting/useHostfullyAccountingRedirect';
import useNotify from 'hooks/useNotify';
import { redirectInNewTab } from 'utils/urlUtils';

const useNavigationAsyncRedirect = () => {
  const { t } = useTranslation();
  const { redirectToGuidebook, isFetching: isFetchingGuidebook } =
    useGuidebookRedirect();
  const { getHostfullyDevicesUrl } = useGetHostfullyDevicesUrl();
  const { redirectToHostfullyAccounting } = useHostfullyAccountingRedirect();
  const { notifyError } = useNotify();

  const redirectToHostfullyDevices = async () => {
    redirectInNewTab({
      getUrl: async () => {
        const hostfullyDevicesUrl = await getHostfullyDevicesUrl();
        return hostfullyDevicesUrl?.data?.url;
      },
      onError: () => notifyError(t('common.hostfullyDevicesAccessError')),
    });
  };

  return {
    redirectToGuidebook,
    redirectToHostfullyDevices,
    redirectToHostfullyAccounting,
    isFetchingGuidebook,
  };
};

export default useNavigationAsyncRedirect;
